module.exports = __webpack_public_path__ + "img/whisper.28033af2.png";